import React from 'react'
import {
  Bullet,
  Bullets,
  Info,
  Page,
  Section,
  Step,
} from '../../components/DocsComponents'
import DocLink from '../../components/DocLink'

const CqcEvidenceGapsActions = () => (
  <Page
    title="CQC Evidence, Gaps, and Assignments"
    intro="Evidence is collected automatically from across AmbuNet and assessed for currency. Anything expired, missing, or weak becomes a gap - fix it at source via its deep link, or assign it to the person who will."
  >
    <Section title="Evidence library">
      <p>
        <DocLink url="/cqc-centre/evidence" text="Evidence Library" /> lists
        every evidence item, filterable by key question, quality statement,
        and status - <strong>Current</strong>, <strong>Expiring Soon</strong>,
        or <strong>Expired</strong>. Most evidence is generated automatically
        from Training, DBS, Appraisals, Policies, Governance, Risk Register,
        Incidents, Feedback, Fleet, and Medicines records.
      </p>
      <Bullets>
        <Bullet>
          Use <strong>Add Evidence</strong> for anything without a natural
          home elsewhere in AmbuNet - pick the quality statement it supports
          and an evidence category, set the evidence date and an optional
          review date and owner, and optionally attach a file. Evidence
          without a file is still valid (for example a note of a verbal
          assurance from a partner organisation).
        </Bullet>
        <Bullet>
          Manually added evidence can be edited or deleted later;
          automatically collected evidence updates itself on each
          recalculation.
        </Bullet>
      </Bullets>
      <Info title="Who can do this?">
        All evidence, gap, and action pages require the Governance team (site
        administrators always have access). The CQC Centre is a tier 2
        feature.
      </Info>
    </Section>

    <Section title="Working the gaps list">
      <p>
        <DocLink url="/cqc-centre/gaps" text="Evidence Gaps" /> lists open
        gaps, filterable by severity (<strong>Critical</strong>,{' '}
        <strong>Important</strong>, <strong>Advisory</strong>), key question,
        and status. For each open gap you can:
      </p>
      <Step number={1} title="Fix it directly">
        <p>
          Every gap carries a button that deep-links to the exact place in
          AmbuNet where the underlying issue is rectified - the DBS dashboard,
          the specific policy or SOP, the vehicle record, the compliance
          question, and so on. Fix the issue at source and the gap resolves
          itself on the next recalculation.
        </p>
      </Step>
      <Step number={2} title="Mark Reviewed (policies and SOPs)">
        <p>
          Where the gap is an overdue policy or SOP review,{' '}
          <strong>Mark Reviewed</strong> records that the document was
          reviewed with no changes needed and sets its next review date - the
          gap clears on the next recalculation.
        </p>
      </Step>
      <Step number={3} title="Assign">
        <p>
          Hand the gap to the person who will fix it - just a name, nothing
          else. The gap itself is the work item: there are no separate tasks,
          due dates, or resolution notes to maintain, and the assignment ends
          automatically when the gap resolves. Assigned gaps (and who holds
          them) appear on the CQC Centre dashboard.
        </p>
      </Step>
      <Info title="Gaps cannot be dismissed">
        A gap only ever closes because the underlying condition was genuinely
        fixed - there is deliberately no dismiss button. This keeps the
        readiness score honest: what you see is what an inspector would find.
      </Info>
    </Section>
  </Page>
)

export default CqcEvidenceGapsActions
